module.exports = __webpack_public_path__ + "img/booongo.45737f8b.svg";